import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './index.css';
import { printDateObjectAsAmericanDate } from '../../../../helpers';
import documentIcon from '../../../../img/document-icon.svg';
import { connect } from 'react-redux';
import { getHistoryManageModeIsOn, getHistoryManageModeSelectedEntries } from '../../../../selectors';
import { Checkbox } from '../../../../components/fields';
import { bindActionCreators } from 'redux';
import { toggleReportsHistoryManageSelectedEntry } from '../../action';

const propTypes = {
    reportIndex: PropTypes.number.isRequired,
    report: PropTypes.object.isRequired,
    allReportsCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
    manageModeIsOn: getHistoryManageModeIsOn(state),
    selectedEntries: getHistoryManageModeSelectedEntries(state),
});

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch,
    toggleReportsHistoryManageSelectedEntry: bindActionCreators(toggleReportsHistoryManageSelectedEntry, dispatch),
});

class SingleReport extends React.Component {
    render() {
        const { report, reportIndex, allReportsCount, manageModeIsOn, selectedEntries } = this.props;

        const firstReport = reportIndex === 0;
        const lastReport = reportIndex + 1 >= allReportsCount;

        const reportRequestDate = new Date(report.reportRequestDate);

        const reportParamsList = report.paramValues ? report.paramValues : [];
        const reportPdfFile = report.file && report.file.reportPdf ? report.file.reportPdf : null;

        const reportClassNames = classNames(s.report, {
            [s.first]: firstReport,
            [s.last]: lastReport,
        });

        const isSelected = selectedEntries.find(e => e === report.reportRequestId) ? true : false;

        return (
            <div
                className={classNames(s.row, {
                    [s.first]: firstReport,
                    [s.last]: lastReport,
                    [s.expanded]: manageModeIsOn,
                })}
            >
                <div className={classNames(reportClassNames, s.name)}>
                    <div>
                        <h3>
                            {'#'}
                            <strong>{report.reportRequestId + ' '}</strong>
                            {report.reportInfo.repTitle}
                        </h3>
                        <h5>{`Date: ${printDateObjectAsAmericanDate(reportRequestDate)}`}</h5>
                    </div>
                </div>

                <div className={classNames(reportClassNames, s.parameters)}>
                    {reportParamsList.length > 0 && (
                        <ol>
                            {reportParamsList.map((param, paramIndex) => (
                                <li key={param.reportParamId}>
                                    <p>
                                        <span>{param.reportParamName + ': '}</span>
                                        <em>{param.reportParamValue}</em>
                                    </p>
                                </li>
                            ))}
                        </ol>
                    )}
                </div>

                <div className={classNames(reportClassNames, s.files)}>
                    {(reportPdfFile && (
                        <a href={reportPdfFile} target="_blank">
                            <em>Download PDF</em>
                            <span>
                                <img src={documentIcon} alt="" />
                            </span>
                        </a>
                    )) || <p>Report not yet generated</p>}
                </div>

                <div
                    className={classNames(reportClassNames, s.deletion, {
                        [s.show]: this.props.manageModeIsOn,
                    })}
                >
                    <Checkbox
                        onChange={this.handleToggleDeletionSelection}
                        checked={isSelected}
                        design={isSelected ? 'warning' : 'default'}
                        label={isSelected ? 'Deselect' : 'Delete'}
                        labelOnLeft={true}
                    />
                </div>
            </div>
        );
    }

    handleToggleDeletionSelection = checked => {
        this.props.toggleReportsHistoryManageSelectedEntry(this.props.report.reportRequestId, checked);
    };
}

SingleReport.propTypes = propTypes;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SingleReport);



// WEBPACK FOOTER //
// ./app/web/src/container/ReportsPage/History/SingleReport/index.jsx